import {lazy} from "../../_snowpack/pkg/react.js";
import {generatePath} from "../../_snowpack/pkg/react-router-dom.js";
export const AesGeneratedSettingsRoute = {
  path: "/:realm/realm-settings/keys/providers/:id/aes-generated/settings",
  component: lazy(() => import("../key-providers/aes-generated/AESGeneratedForm.js")),
  breadcrumb: (t) => t("realm-settings:editProvider"),
  access: "view-realm"
};
export const toAesGeneratedSettings = (params) => ({
  pathname: generatePath(AesGeneratedSettingsRoute.path, params)
});
